import { motion } from 'framer-motion';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-[#050505]">
      <Navbar />
      
      <section className="pt-32 pb-24" data-testid="about-page">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <span className="text-xs tracking-[0.3em] uppercase text-[#FFFFFF] mb-4 block">About</span>
            <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter mb-8">
              Built in Germany
            </h1>
            
            <div className="prose prose-invert prose-lg max-w-none">
              <p className="text-white/70 text-lg leading-relaxed mb-8">
                WrapViz was born from a simple observation: wrap studios were losing sales because 
                customers couldn't visualize the end result. 3D configurators with generic car models 
                weren't cutting it.
              </p>

              <p className="text-white/70 text-lg leading-relaxed mb-8">
                We built a solution that uses the customer's actual car photo to generate 
                photoreal wrap previews. No generic models. No guesswork. Just real results 
                that help close deals.
              </p>

              <div className="bg-[#0F0F0F] border border-white/10 rounded-sm p-8 my-12">
                <h2 className="text-2xl font-bold mb-4">Our Mission</h2>
                <p className="text-white/60">
                  To help premium wrap studios showcase their work in the most compelling way possible, 
                  turning browsers into buyers with photoreal visualization technology.
                </p>
              </div>

              <h2 className="text-2xl font-bold mb-4 mt-12">Why WrapViz?</h2>
              
              <ul className="space-y-4 text-white/70">
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FFFFFF] mt-2.5 flex-shrink-0"></span>
                  <span><strong className="text-white">Real photos, not renders.</strong> Your customer's actual car becomes the canvas.</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FFFFFF] mt-2.5 flex-shrink-0"></span>
                  <span><strong className="text-white">Premium positioning.</strong> The template and experience match your high-end service.</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FFFFFF] mt-2.5 flex-shrink-0"></span>
                  <span><strong className="text-white">Self-serve simplicity.</strong> No calls, no contracts. Sign up and go live today.</span>
                </li>
              </ul>

              <div className="mt-16 pt-8 border-t border-white/10">
                <h3 className="text-xl font-bold mb-4">Contact</h3>
                <p className="text-white/60">
                  Have questions? Reach out at{' '}
                  <a href="mailto:embermotors@gmail.com" className="text-[#FFFFFF] hover:underline">
                    embermotors@gmail.com
                  </a>
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
